import type { LocaleContextProps } from '@app/src/context/LocaleContext'
import LocaleContext from '@app/src/context/LocaleContext'
import { CACHED_LOCALE_STORAGE_KEY } from '@app/src/i18n'
import { DEFAULT_LANGUAGE } from '@app/src/wf-constants'
import type { ReactNode } from 'react'
import React, { useEffect, useState } from 'react'

interface Props {
  children: ReactNode
}

const LocaleContextProvider = ({ children }: Props): JSX.Element => {
  const [locale, setLocale] = useState<LocaleContextProps['locale']>(
    () => localStorage.getItem(CACHED_LOCALE_STORAGE_KEY) || DEFAULT_LANGUAGE,
  )
  useEffect(() => {
    if (localStorage.getItem(CACHED_LOCALE_STORAGE_KEY) !== locale) {
      localStorage.setItem(CACHED_LOCALE_STORAGE_KEY, locale)
    }
  }, [locale])

  return <LocaleContext.Provider value={{ locale, setLocale }}>{children}</LocaleContext.Provider>
}

export default LocaleContextProvider
